import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiForgotPasswordByEmail,
  apiForgotPasswordByPhone,
} from '../services/apis';
import * as actions from '../redux/forgotPassword';
import { showAlertBanner } from '../redux/alertBanner';
import { getAuthType } from '@dragonfruit/redux/forgotPassword';
import {
  ALERT_ERROR_THEME,
  ALERT_SUCCESS_THEME,
} from '@dragonfruit/constants/alertBannerThemes';
import { PHONE } from '@dragonfruit/constants/signupAuthType';

export function* forgotPassword(action) {
  const { email, locale, phoneNumber, countryCode } = action.payload;

  const authType = yield select(getAuthType);

  try {
    let messageKey = '';
    if (authType === PHONE) {
      yield call(apiForgotPasswordByPhone, {
        phone: phoneNumber,
        country_code: countryCode,
      });
      messageKey = 'common:common.sendSMSSuccess';
    } else {
      yield call(apiForgotPasswordByEmail, {
        email,
        locale,
      });
      messageKey = 'common:common.sendEmailSuccess';
    }

    yield put(actions.forgotPasswordSuccess());
    yield put(
      showAlertBanner({
        message: messageKey,
        theme: ALERT_SUCCESS_THEME,
      })
    );
  } catch (err) {
    yield put(actions.forgotPasswordError(err.message));
    yield put(
      showAlertBanner({
        message: err.message,
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(actions.FORGOT_PASSWORD, forgotPassword)]);
}



// WEBPACK FOOTER //
// ./app/sagas/forgotPassword.js